import { render, staticRenderFns } from "./TemplateBe.vue?vue&type=template&id=fd884ad6&scoped=true"
import script from "./TemplateBe.ts?vue&type=script&lang=ts&external"
export * from "./TemplateBe.ts?vue&type=script&lang=ts&external"
import style0 from "./TemplateBe.scss?vue&type=style&index=0&id=fd884ad6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd884ad6",
  null
  
)

export default component.exports